// extracted by mini-css-extract-plugin
module.exports = {"specifications":"vd__3Pbqd","specificationsItem":"vd__2BwS1","footer":"vd__3oNTD"};